import FormikWizard from "formik-wizard"
import { useFormikWizard } from "formik-wizard"
import React from "react"
import AssetsOverAmount from "../steps/AssetsOverAmount"
import schema from "../schema"
import _ from "lodash"
function FormWrapper({
  children,
  isLastStep,
  status,
  goToPreviousStep,
  canGoBack,
  actionLabel,
  wizard,
}) {
  const { values } = useFormikWizard()

  function BackToValueCare() {
    values.valuecare.valueover = 0
    wizard.push("valuecare")
  }

  function BackToStart() {
    window.location.reload()
  }

  if (!_.isNil(document.getElementById("asc-form-submit"))) {
    document
      .getElementById("asc-form-submit")
      .addEventListener("click", function () {
        //scroll(0,0)
      })
  }

  return (
    <div>
      {canGoBack && values.valuecare.valueover != 1 && (
        <div className="transaction-header mtop-20 mbottom-30">
          <button
            onClick={goToPreviousStep}
            disabled={!canGoBack}
            id="previous"
            type="button"
            className="button--back prev-step"
            aria-label="Back a step"
          >
            <i class="fa fa-angle-left"></i> Back
          </button>
        </div>
      )}
      <div className="form-content">
        {
          /**
           * If Assets are over the amount (first question) then they can not progress and show the user the AssetsOverAmount screen
           */
          values.valuecare.valueover == 1 && (
            <div>
              <div className="transaction-header mtop-20 mbottom-30">
                <button
                  onClick={BackToValueCare}
                  id="previous2"
                  type="button"
                  className="button--back prev-step"
                  aria-label="Back a step"
                >
                  <i class="fa fa-angle-left"></i> Back
                </button>
              </div>
              <AssetsOverAmount />
              <div>
                <a onClick={BackToStart}>Start again</a>
              </div>
            </div>
          )
        }

        {status && (
          <div>
            <h2>Cost of your care</h2>
            <h3>Your contribution</h3>
            {status.contribute || status.savings ? (
              <div>
                <div
                  id="contributeamount"
                  className="alert alert__message alert--state-info"
                >
                  <p>{status.contribute}</p>
                </div>
                <p className="mtop-20">
                  Total value of your savings: £
                  <span id="totalsavings">{status.savings}</span>
                </p>
                <p className="mtop-20">
                  Type of care selected: {status.caretype}
                </p>
                <p>
                  This is only an estimated amount. In some circumstances the
                  value of your property may be disregarded. For a full
                  financial assessment please contact the Finance and Benefits
                  Team on <a href="tel:01454 864269">01454 864269</a> or email{" "}
                  <a href="mailto:FABTEAM@southglos.gov.uk">
                    FABTEAM@southglos.gov.uk
                  </a>
                </p>
                <p>
                  You can find more information on care and support charges and
                  financial assessments on our{" "}
                  <a
                    rel="noreferrer"
                    href="https://www.southglos.gov.uk/health-and-social-care/money-information-and-advice/paying-for-your-support/"
                  >
                    Funding care and support page
                  </a>
                  .
                </p>
                <p>
                  Many people arrange their own care at home. The{" "}
                  <a
                    rel="noreferrer"
                    href="https://find-information-for-adults-children-families.southglos.gov.uk/kb5/southglos/directory/adult.page?adultchannel=0&channel=adult"
                    target="_blank"
                  >
                    South Gloucestershire Find information for adults, children
                    and families
                  </a>{" "}
                  website has information about local services that can support
                  you to live at home and be as independent as possible. For
                  example; help with care (washing, dressing, toileting needs)
                  and household tasks (cooking, cleaning, shopping).{" "}
                </p>
                <p>
                  <a
                    rel="noreferrer"
                    href="https://find-information-for-adults-children-families.southglos.gov.uk/kb5/southglos/directory/results.page?adultchannel=1-1&channel=adult&adv_sr=0"
                    target="_blank"
                  >
                    Equipment, adaptations and technology
                  </a>{" "}
                  can also help you to live at home more independently.{" "}
                </p>
                <p>
                  If you have a long-term physical or mental illness or
                  disability and are aged over 65 you may be able to get
                  financial support with the{" "}
                  <a
                    rel="noreferrer"
                    href="https://www.gov.uk/attendance-allowance"
                    target="_blank"
                  >
                    Attendance Allowance.
                  </a>
                </p>
              </div>
            ) : (
              <div className="validation-summary" role="alert">
                <h4>Something went wrong</h4>
                <p>We were unable to work out the value.</p>
                <p>Try again later.</p>
              </div>
            )}
          </div>
        )}

        {!status && values.valuecare.valueover != 1 && (
          <div>
            {children}
            <div className="transaction-footer">
              <button
                type="submit"
                id="asc-form-submit"
                className="button--next next-step button button--primary"
              >
                {actionLabel || (isLastStep ? "Submit" : "Continue")}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

function App() {
  const handleSubmit = React.useCallback(values => {
    /**
     * Handles
     */

    const dre_full = 10.0
    const dre_zero = 0.0
    const basicAllowanceAmount = 24.9
    const propertyAssetsDeduction = 14250
    const totalAssetsThreshold = 23250
    const AA_H = 87.65
    const AA_H_adjustment = 58.7
    const DLA_C_H = 87.65
    const DLA_C_H_adjustment = 58.7
    const DLA_M_H = 61.2
    const DLA_M_H_adjustment = 23.2
    const PIP_C_H = 87.65
    const PIP_C_H_adjustment = 58.7
    const PIP_M_H = 61.2
    const PIP_M_H_adjustment = 23.2
    const maxWeeklyChargeAmount = 194.7
    const childAdditionalAmount = 86.2
    const lp_notcarer_lower_allowance = 135.7
    const basicAllowanceDefault = 194.7
    const lp_carer_lower_allowance = 180.25
    const lp_notcarer_higher_allowance = 156.0
    const lp_carer_higher_allowance = 200.55
    const carer_child_allowance = 138.7
    const carer_overstate_allowance = 239.25
    const carer_25state_higher_allowance = 200.55

    //set the constiables we will use
    const typeOfCare = values.valuecare.typeofcare
    let typeOfCareLabel
    if (typeOfCare === "0") {
      //Care at home
      typeOfCareLabel = "Care at home"
    } else if (typeOfCare === "1") {
      //Residential
      typeOfCareLabel = "Residential"
    } else if (typeOfCare === "2") {
      //Short stay
      typeOfCareLabel = "Short stay"
    } else {
      // not found
    }

    //populate the type of care span
    //@todo RUSS COMEBACK TO THIS jQuery('#typeofcare-selected').html(typeOfCareLabel);
    const propertyValue = values.property.propertyvalue
    console.log("propertyvalue" + propertyValue)
    const anyApply = values.followingapply

    let ageGroup
    if (values.age.loneparent !== null) {
      ageGroup = values.age.age
    } else {
      ageGroup = values.age.loneparent
    }

    //mortgage loan amount
    let mortgageLoanAmount = 0
    const mortgageLoanAmountCalc = values.property.mortgageloan
    if (mortgageLoanAmountCalc === "1") {
      mortgageLoanAmount = values.property.mortgageloanamountvalue
      console.log("mortgageLoanAmount" + mortgageLoanAmount)
    }

    let propertyAssets = 0
    let totalAssets = 0
    let assetIncome = 0
    let contributeAmount = 0
    let totalSavings = 0

    const isCarer = values.age.carer

    const childCount = values.age.childrenunder18

    ////assets
    //bankaccounts
    const bankAccounts = values.accounts.bankaccounts
    console.log("bankAccounts" + bankAccounts)

    //post office
    const postOffice = values.accounts.postoffice
    console.log("postOffice" + postOffice)

    //isa
    const isa = values.accounts.isa
    console.log("isa" + isa)

    //shares
    const shares = values.accounts.shares
    console.log("shares" + shares)
    //premium bonds
    const premiumBonds = values.accounts.premiumbonds
    console.log("premiumBonds" + premiumBonds)
    //income bonds
    const incomeBonds = values.accounts.incomebond
    console.log("incomeBonds" + incomeBonds)

    //national savings certs
    const nationalSavingsCerts = values.accounts.nationalsavingscerts
    console.log("nationalSavingsCerts" + nationalSavingsCerts)

    //building society
    const buildingSociety = values.accounts.buildingsociety
    console.log("buildingSociety" + buildingSociety)
    const otherAssets = values.accounts.otheraccountsassets
    console.log("otherAssets" + otherAssets)
    /////totalAssets is used later to calcuate the above assets

    //state pension42.27
    const statePensionCalc = values.pension.statepension_per
    let statePension
    if (statePensionCalc === "0") {
      statePension = values.pension.statepension_name
      console.log("1statePension" + statePension)
    } else {
      //they have entered monthly and we need to convert to weekly figure for calculation
      // this is actually / 4 instead as we ask "four weekly"
      statePension = values.pension.statepension_name / 4

      console.log("2statePension" + statePension)
    }
    //private pension
    let privatePension
    const privatePensionCalc = values.pension.privatepensions
    const pensionHalf = values.pension.passpensionon
    if (privatePensionCalc === 0) {
      if (pensionHalf === "1") {
        //if half then we half it
        privatePension = values.pension.privatepensions_name / 2
        console.log("1privatePension-halfed" + privatePension)
      } else {
        privatePension = values.pension.privatepensions_name
        console.log("2privatePension-halfed do not half" + privatePension)
      }
    } else {
      //they have entered monthly and we need to convert to weekly figure for calculation
      if (pensionHalf === "1" && typeOfCare === "1") {
        //if half then we half it, and they are residential
        privatePension = (values.pension.privatepensions_name * 12) / 52
        privatePension = values.pension.privatepensions_name / 2
        console.log("3privatePension-halfed" + privatePension)
      } else {
        //if they are not residential, or clicked no then we don't divide
        privatePension = (values.pension.privatepensions_name * 12) / 52
        console.log("4privatePension-halfed" + privatePension)
      }
    }

    //divide by 4 (monthly to weekly) or not (weekly == weekly)
    if (values.pension.privatepension_per === "1") {
      //divide by 4 as they have entered it monthly and we need the weekly rate
      privatePension = privatePension / 4
      console.log("Private Pension is to be divided by 4 as WEEKLY")
    } else {
      // do nothing, as it it's already weekly.
      console.log("Private Pension is monthly rate")
    }

    //pension guaranteed credit
    let pensionGc
    const pensionGcCalc = values.pension.pensionsavingscredit_per
    if (pensionGcCalc === "0") {
      pensionGc = values.pension.pensioncredit
      console.log("pensionGc" + pensionGc)
    } else {
      //they have entered monthly and we need to convert to weekly figure for calculation
      // this is actually / 4 instead as we ask "four weekly"
      pensionGc = values.pension.pensionsavingscredit_per / 4
      console.log("pensionGc" + pensionGc)
    }

    //pension credit savings
    let pensionCsc
    const pensionCscCalc = values.pension.pensionsavingscredit_per
    if (pensionCscCalc === "0") {
      pensionCsc = values.pension.pensionsavingscredit
      console.log("pensionCsc" + pensionCsc)
    } else {
      //they have entered monthly and we need to convert to weekly figure for calculation
      // this is actually / 4 instead as we ask "four weekly"
      pensionCsc = values.pension.pensionsavingscredit / 4
      console.log("pensionCsc" + pensionCsc)
    }

    //employment support allowance
    let employmentS
    const employmentSCalc = values.benefits.employmentsupport_per
    if (employmentSCalc === "0") {
      employmentS = values.benefits.employmentsupport
      console.log("employmentS" + employmentS)
    } else {
      //they have entered monthly and we need to convert to weekly figure for calculation
      // this is actually / 4 instead as we ask "four weekly"
      employmentS = values.benefits.employmentsupport / 4
      console.log("employmentS" + employmentS)
    }

    //income support
    let incomeSupport
    const incomeSupportCalc = values.benefits.incomesupport_per
    if (incomeSupportCalc === "0") {
      incomeSupport = values.benefits.incomesupport
      console.log("incomeSupport" + incomeSupport)
    } else {
      //they have entered monthly and we need to convert to weekly figure for calculation
      // this is actually / 4 instead as we ask "four weekly"
      incomeSupport = values.benefits.incomesupport / 4
      console.log("incomeSupport" + incomeSupport)
    }

    //universal credit
    let universalCredit
    const universalCreditCalc = values.benefits.universalcredit_per
    if (universalCreditCalc === "0") {
      universalCredit = values.benefits.universalcredit
      console.log("universalCredit" + universalCredit)
    } else {
      //they have entered monthly and we need to convert to weekly figure for calculation
      universalCredit = (values.benefits.universalcredit * 12) / 52
      console.log("universalCredit" + universalCredit)
    }

    //carers allowance amount
    let carersAllowance
    const carersAllowanceCalc = values.benefits.carersallowance_per
    if (carersAllowanceCalc === "0") {
      carersAllowance = values.benefits.carersallowance
      console.log("carersallowance" + carersAllowance)
    } else {
      //they have entered monthly and we need to convert to weekly figure for calculation
      carersAllowance = (values.benefits.carersallowance * 12) / 52
      console.log("carersallowance" + carersAllowance)
    }

    //other benefits
    let otherBenefits
    const otherBenfitsCalc = values.benefits.otherbenefits_per
    if (otherBenfitsCalc === "0") {
      otherBenefits = values.benefits.otherbenefits
      console.log("otherBenefits" + otherBenefits)
    } else {
      //they have entered monthly and we need to convert to weekly figure for calculation
      otherBenefits = (values.benefits.otherbenefits * 12) / 52
      console.log("otherBenefits" + otherBenefits)
    }

    //attendance allowance
    let attendanceAllowance = values.benefits.attendanceallowance
    console.log("attendanceAllowance" + attendanceAllowance)

    //disability living allowance care
    let disabilityLivingAllowanceCare = values.benefits.disabilityallowance
    console.log("disabilityLivingAllowanceCare" + disabilityLivingAllowanceCare)

    //disability living allowance mobility
    let disabilityLivingAllowanceMobility = values.benefits.disabilitymobility
    console.log(
      "disabilityLivingAllowanceMobility" + disabilityLivingAllowanceMobility
    )

    //PIP
    let PIP = values.benefits.personalindepenence
    console.log("PIP" + PIP)

    //PIP Mobility
    let PIPm = values.benefits.personalindepenence_mobility
    console.log("PIPm" + PIPm)

    //mortgage
    let mortgage
    const mortgageCalc = values.expenses.mortgage_per
    if (mortgageCalc === "0") {
      mortgage = values.expenses.mortgage
      console.log("mortgage" + mortgage)
    } else {
      //they have entered monthly and we need to convert to weekly figure for calculation
      mortgage = (values.expenses.mortgage * 12) / 52
      console.log("mortgage" + mortgage)
    }

    //rent
    let rent
    const rentCalc = values.expenses.rent_per
    if (rentCalc === "0") {
      rent = values.expenses.rent
      console.log("rent" + rent)
    } else {
      //they have entered monthly and we need to convert to weekly figure for calculation
      rent = (values.expenses.rent * 12) / 52
      console.log("rent" + rent)
    }

    // counciltax
    let councilTax
    const councilTaxCalc = values.expenses.counciltax_per
    if (councilTaxCalc === "0") {
      councilTax = values.expenses.counciltax
      console.log("councilTax" + councilTax)
    } else {
      //they have entered monthly and we need to convert to weekly figure for calculation
      councilTax = (values.expenses.counciltax * 12) / 52
      console.log("councilTax" + councilTax)
    }

    //disability related expenditure
    let disabilityRelated
    //disability related expenditure, flat rate of £10.00 that is added for all non residential users
    if (typeOfCare !== 1) {
      //the user is non residential, so we add £10.00 for DRE
      //@json file: dre_full
      disabilityRelated = parseFloat(dre_full)
      console.log("disabilityRelatedb" + disabilityRelated)
    } else {
      //residential, so DRE is 0
      //@json file:dre_zero
      disabilityRelated = parseFloat(dre_zero)
      console.log("disabilityRelateda" + disabilityRelated)
    }

    /* updated 
        const disabilityRelatedCalc = jQuery('input[name="disabilityrelatedexpend_per"]:checked').val();
         if(disabilityRelatedCalc == 0){
             disabilityRelated = parseFloat(jQuery('#disabilityrelatedexpend').val()).toFixed(2);
             //console.log('disabilityRelated'+disabilityRelated);
         } else {
             //they have entered monthly and we need to convert to weekly figure for calculation
             disabilityRelated =  parseFloat(jQuery('#disabilityrelatedexpend').val()* 12/52 ).toFixed(2);
             //console.log('disabilityRelated'+disabilityRelated);
         }*/

    //service charge
    let serviceCharge
    const serviceChargeCalc = values.expenses.servicecharge_per
    if (serviceChargeCalc === "0") {
      serviceCharge = values.expenses.servicecharge
      console.log("serviceCharge" + serviceCharge)
    } else {
      //they have entered monthly and we need to convert to weekly figure for calculation
      serviceCharge = (values.expenses.servicecharge * 12) / 52
      console.log("serviceCharge" + serviceCharge)
    }

    //water charge
    let waterCharge
    const waterChargeCalc = values.expenses.watercharge_per
    if (waterChargeCalc === "0") {
      waterCharge = values.expenses.watercharge
      console.log("waterCharge" + waterCharge)
    } else {
      //they have entered monthly and we need to convert to weekly figure for calculation
      waterCharge = (values.expenses.watercharge * 12) / 52

      console.log("waterCharge" + waterCharge)
    }

    //ground rent
    let groundRent
    const groundRentCalc = values.expenses.groundrent_per
    if (groundRentCalc === "0") {
      groundRent = values.expenses.groundrent
      console.log("groundRent" + groundRent)
    } else {
      //they have entered monthly and we need to convert to weekly figure for calculation
      groundRent = (values.expenses.groundrent * 12) / 52
      console.log("groundRent" + groundRent)
    }

    //buildings insurance
    let buildingsInsurance
    const buildingsInsuranceCalc = values.expenses.buildinginsurance_per
    if (buildingsInsuranceCalc === "0") {
      buildingsInsurance = values.expenses.buildinginsurance
      console.log("buildingsInsurance" + buildingsInsurance)
    } else {
      //they have entered monthly and we need to convert to weekly figure for calculation
      buildingsInsurance = (values.expenses.buildinginsurance * 12) / 52
      console.log("buildingsInsurance" + buildingsInsurance)
    }

    //contents insurance
    let contentsInsurance
    const contentsInsuranceCalc = values.expenses.contentsinsurance_per
    if (contentsInsuranceCalc === "0") {
      contentsInsurance = values.expenses.contentsinsurance
      console.log("contentsInsurance" + contentsInsurance)
    } else {
      //they have entered monthly and we need to convert to weekly figure for calculation
      contentsInsurance = (values.expenses.contentsinsurance * 12) / 52
      console.log("contentsInsurance" + contentsInsurance)
    }

    let income
    let chargableIncome
    let maxWeeklyCharge
    //@json file: basicAllowanceAmount
    let basicAllowance = parseFloat(basicAllowanceAmount).toFixed(2)

    let propertyAssetsCalc
    if (propertyAssets <= 0) {
      //@json file: propertyAssetsDeduction
      propertyAssetsCalc = parseFloat(propertyAssetsDeduction)
    } else {
      //@json file: propertyAssetsDeduction
      propertyAssetsCalc =
        parseFloat(propertyAssets) - parseFloat(propertyAssetsDeduction)
    }

    //RESIDENTIAL PAYMENTS
    if (typeOfCare === "1") {
      console.log("RESIDENTIAL")
      //console.log(anyApply);

      // they selected residential, calculate it and display on results

      //calculate propertyAssets
      if (propertyValue.length > 0 && anyApply === "0") {
        //they entered a property value, and any apply is no
        propertyAssets =
          parseFloat(propertyValue) - parseFloat(mortgageLoanAmount)
        //if its less than 0, then set it to 0.00
        if (parseFloat(propertyAssets) < 0) {
          propertyAssets = parseFloat(0.0)
          console.log("property assets less than 0")
        }
        //console.log('value is greater than 0, and any apply is false')
      } else if (anyApply === "1") {
        //console.log('propertyassets was either 0, or anyApply is true');
        //if they select Yes, then propertyValue is not used
        propertyAssets = mortgageLoanAmount
        //if(parseFloat(propertyAssets) < 0 ) {
        //    propertyAssets = parseFloat(0.00);
        console.log("property assets less than 0")
        // }

        propertyAssets = parseFloat(0.0)
      }

      //calculate totalAssets, round down to nearest whole number
      totalAssets =
        parseFloat(propertyAssets) +
        parseFloat(bankAccounts) +
        parseFloat(postOffice) +
        parseFloat(isa) +
        parseFloat(shares) +
        parseFloat(premiumBonds) +
        parseFloat(incomeBonds) +
        parseFloat(nationalSavingsCerts) +
        parseFloat(buildingSociety) +
        parseFloat(otherAssets)
      console.log("totalassetsare" + totalAssets)
      totalAssets = totalAssets.toFixed(2)

      if (parseFloat(totalAssets) < 0) {
        //if its less than 0 then set it 0
        totalAssets = parseFloat(0.0)
        console.log("total assets was less than 0")
      }
      console.log("totalassets res:" + totalAssets)
      //calculate assetIncome
      //if propertyassets is less than 0, then set it to 0.

      assetIncome = Math.ceil(
        (parseFloat(totalAssets) - propertyAssetsCalc) / 250
      )
      assetIncome = assetIncome.toFixed(2)
      if (parseFloat(assetIncome) < 0) {
        assetIncome = parseFloat(0.0)
        console.log("asset income was less than 0")
      }

      console.log("assetincome:" + assetIncome)
      //calculate income

      //PIP-M, DLA-M is not used in logic
      income =
        parseFloat(assetIncome) +
        parseFloat(statePension) +
        parseFloat(privatePension) +
        parseFloat(pensionGc) +
        parseFloat(pensionCsc) +
        parseFloat(attendanceAllowance) +
        parseFloat(disabilityLivingAllowanceCare) +
        parseFloat(PIP) +
        parseFloat(employmentS) +
        parseFloat(incomeSupport) +
        parseFloat(universalCredit) +
        parseFloat(otherBenefits)
      income = income.toFixed(2)
      console.log("income:" + income)
      //calculate chargable income
      const chargableIncomeSum =
        parseFloat(waterCharge) +
        parseFloat(groundRent) +
        parseFloat(buildingsInsurance) +
        parseFloat(contentsInsurance)
      chargableIncome = parseFloat(income) - parseFloat(chargableIncomeSum)
      chargableIncome = chargableIncome.toFixed(2)
      if (parseFloat(chargableIncome < 0)) {
        chargableIncome = parseFloat(0.0)
        console.log("chargable income less than 0")
      }
      console.log("chargableIncome:" + chargableIncome)

      //if total assets are over totalAssetsThreshold, then they have to pay full costs
      //@json file: totalAssetsThreshold
      if (totalAssets > totalAssetsThreshold) {
        contributeAmount = "You may have to pay full costs for your care"
        console.log("may have to pay full")
        // jQuery('#contributeamount').html('<p>You may have to pay full costs for your care</p>');
      }
      //calcualte max weekly charge
      else if (parseFloat(chargableIncome) - parseFloat(basicAllowance) < 0) {
        //console.log('chargable income - basicallowance was less than 0');
        // if its 0 or less
        //maxWeeklyCharge = 0;
        maxWeeklyCharge = parseFloat(
          (chargableIncome - basicAllowance).toFixed(2)
        )
        //update how much they need to pay
        //jQuery('#contributeamount').html('<p>You may have to contribute up to £0 a week towards the cost of your care</p>');
        contributeAmount =
          "You may have to contribute up to £0 a week towards the cost of your care"
        console.log("may have to pay 0")
      } else {
        // its not 0 or less, therefor greater and we calculate it. the user needs to contribute
        maxWeeklyCharge = parseFloat(
          (chargableIncome - basicAllowance).toFixed(2)
        )
        //console.log(maxWeeklyCharge);
        if (maxWeeklyCharge < 0) {
          //if in negatives, they have to pay 0.00 towards
          maxWeeklyCharge = 0
          //console.log('max weekly charge was less than 0');
        }
        //update how much they need to pay
        //jQuery('#contributeamount').html('<p>You may need to contribute up to £' + maxWeeklyCharge.toFixed(2) + ' a week towards the cost of your care</p>');
        contributeAmount =
          "You may need to contribute up to £" +
          maxWeeklyCharge.toFixed(2) +
          " a week towards the cost of your care"
        console.log("may have to pay X")
      }
      //update the total savings on screen
      // jQuery('#totalsavings').html(totalAssets);
      totalSavings = totalAssets
      //    debugger;
    } else {
      console.log("NON RESIDENTIAL OR SHORT STAY ASSESSMENT")
      // non residential assents or short stay assessment
      propertyAssets = parseFloat(0.0)
      //calculate totalAssets, round down to nearest whole number
      totalAssets =
        parseFloat(bankAccounts) +
        parseFloat(postOffice) +
        parseFloat(isa) +
        parseFloat(shares) +
        parseFloat(premiumBonds) +
        parseFloat(incomeBonds) +
        parseFloat(nationalSavingsCerts) +
        parseFloat(buildingSociety) +
        parseFloat(otherAssets)
      totalAssets = totalAssets.toFixed(2)
      if (parseFloat(totalAssets) < 0) {
        totalAssets = parseFloat(0.0)
        //console.log('total assets less than 0');
      }
      console.log("totalassets no res:" + totalAssets)
      //@json file: AA_H
      //@json file: AA_H_adjustment
      console.log(AA_H)
      if (parseFloat(attendanceAllowance) === parseFloat(AA_H)) {
        attendanceAllowance = parseFloat(AA_H_adjustment)
        //console.log('AA was higher, and nonresidential, changed to 58.70');
      }
      //is higher
      //@json file: DLA_C_H
      //@json file: DLA_C_H_adjustment
      //
      if (parseFloat(disabilityLivingAllowanceCare) === parseFloat(DLA_C_H)) {
        disabilityLivingAllowanceCare = parseFloat(DLA_C_H_adjustment)
        //console.log('DLA-C was higher, and nonresidential, changed to 58.70');
      }
      //is higher
      //@json file: DLA_M_H
      //@json file: DLA_M_H_adjustment
      if (
        parseFloat(disabilityLivingAllowanceMobility) === parseFloat(DLA_M_H)
      ) {
        disabilityLivingAllowanceMobility = parseFloat(DLA_M_H_adjustment)
        //console.log('DLA-M was higher, and nonresidential, changed to 23.20');
      }
      //is higher
      //higherPIP
      //@json file: PIP_C_H
      //@json file: PIP_C_H_adjustment
      if (parseFloat(PIP) === parseFloat(PIP_C_H)) {
        PIP = parseFloat(PIP_C_H_adjustment)
        //console.log('PIP-C was higher, and nonresidential, changed to 58.70');
      }
      //is higher
      //@json file: PIP_M_H
      //@json file: PIP_M_H_adjustment
      if (parseFloat(PIPm) === parseFloat(PIP_M_H)) {
        PIPm = parseFloat(PIP_M_H_adjustment)
        //console.log('PIP-M was higher, and nonresidential, changed to 23.20');
      }

      //calculate assetIncome

      assetIncome = Math.ceil(
        (parseFloat(totalAssets) - propertyAssetsCalc) / 250
      )
      assetIncome = assetIncome.toFixed(2)
      if (parseFloat(assetIncome) < 0) {
        assetIncome = parseFloat(0.0)
        //console.log('assetincome less than 0;')
      }
      console.log("assetincome:" + assetIncome)

      //calculate income
      income =
        parseFloat(assetIncome) +
        parseFloat(statePension) +
        parseFloat(privatePension) +
        parseFloat(pensionGc) +
        parseFloat(pensionCsc) +
        parseFloat(attendanceAllowance) +
        parseFloat(disabilityLivingAllowanceCare) +
        parseFloat(PIP) +
        parseFloat(employmentS) +
        parseFloat(incomeSupport) +
        parseFloat(universalCredit) +
        parseFloat(otherBenefits) +
        parseFloat(carersAllowance)
      income = income.toFixed(2)
      console.log("income:" + income)

      //calculate chargable income
      const chargableIncomeSum =
        parseFloat(mortgage) +
        parseFloat(rent) +
        parseFloat(councilTax) +
        parseFloat(serviceCharge) +
        parseFloat(waterCharge) +
        parseFloat(groundRent) +
        parseFloat(buildingsInsurance) +
        parseFloat(contentsInsurance) +
        parseFloat(disabilityRelated)

      console.log(mortgage)
      console.log(rent)
      console.log(councilTax)
      console.log(serviceCharge)
      console.log(waterCharge)
      console.log(groundRent)
      console.log(buildingsInsurance)
      console.log(contentsInsurance)
      console.log(disabilityRelated)
      console.log("chargableIncomeSum" + chargableIncomeSum)

      chargableIncome = parseFloat(income) - parseFloat(chargableIncomeSum)
      console.log("chargableIncome" + chargableIncome)

      chargableIncome = chargableIncome.toFixed(2)

      console.log("chargableIncome" + chargableIncome)
      if (parseFloat(chargableIncome) < 0) {
        chargableIncome = parseFloat(0.0)
        console.log("chargableincome is less than 0")
      }
      console.log("chargableIncome:" + chargableIncome)

      //if total assets are over totalAssetsThreshold, then they have to pay full costs
      //@json file: totalAssetsThreshold
      if (totalAssets > totalAssetsThreshold) {
        contributeAmount = "You may have to pay full costs for your care"

        console.log("may have to pay full")
      }
      //calcualte max weekly charge
      else if (parseFloat(chargableIncome) - parseFloat(basicAllowance) < 0) {
        // if its 0 or less
        //maxWeeklyCharge = 0;
        maxWeeklyCharge = parseFloat(
          (chargableIncome - basicAllowance).toFixed(2)
        )
        if (maxWeeklyCharge < 0) {
          maxWeeklyCharge = 0.0
        }
        contributeAmount =
          "You may need to contribute up to £" +
          maxWeeklyCharge +
          " a week towards the cost of your care"
        console.log("may have to pay X")
      } else {
        //start maxWeeklyCharge as base maxWeeklyChargeAmount
        //@json file: maxWeeklyChargeAmount
        maxWeeklyCharge = parseFloat(maxWeeklyChargeAmount)
        //calculate basic allowance based on answers
        //for each child, add childAdditionalAmount
        //@json file: childAdditionalAmount
        const childAdditional =
          parseFloat(childAdditionalAmount) * parseFloat(childCount)
        childAdditional.toFixed(2)

        //if lone parent it superceeds the other 3 values
        if (ageGroup === "loneparent") {
          // Disability Living Allowance Lower Rate or PIP Standard rate or Entitled to Armed Forces Independence Payment or Attendance Allowance Lower Rate
          // if ((isCarer == 0) && ((jQuery('#disabilityallowance_lower:checked').val()) || (jQuery('#disabilitymobility_lower:checked').val()) || (jQuery('#personalindepenence_lower:checked').val()) || (jQuery('#personalindepenence_mobility_lower:checked').val()) || (jQuery('#armedforces_yes:checked').val()) || (jQuery('#attendanceallowance_lower:checked').val()))) {
          if (
            isCarer === "0" &&
            (values.benefits.disabilityallowance_lower === "1" ||
              values.benefits.disabilitymobility_lower === "1" ||
              values.benefits.personalindepenence_lower === "1" ||
              values.benefits.personalindepenence_mobility_lower === "1" ||
              values.benefits.armedforces_yes === "1" ||
              values.benefits.attendanceallowance_lower === "1")
          ) {
            //@json file: lp_notcarer_lower_allowance
            basicAllowance =
              parseFloat(lp_notcarer_lower_allowance) +
              parseFloat(childAdditional)
            //console.log('basicallowanceis' + basicAllowance);
            maxWeeklyCharge =
              parseFloat(chargableIncome) - parseFloat(basicAllowance)
            //console.log('maxweeklycharge' + maxWeeklyCharge);
            //console.log('childaddis' + childAdditional);
            //@json file: basicAllowanceDefault
            if (basicAllowance < parseFloat(basicAllowanceDefault)) {
              //@json file: basicAllowanceDefault
              maxWeeklyCharge =
                parseFloat(chargableIncome) - parseFloat(basicAllowanceDefault)
              //console.log('5');
            } else {
              // nothing, this is the max weekly charge as added up.
              maxWeeklyCharge =
                parseFloat(chargableIncome) - parseFloat(basicAllowance)
              //console.log('6');
            }
          }

          // Carer and Disability Living Allowance Lower/Med Rate or PIP standard rate or Entitled to Armed Forces Independence Payment or Attendance Allowance Lower Rate?
          // else if ((isCarer == 1) && ((jQuery('#disabilityallowance_lower:checked').val()) || (jQuery('#disabilitymobility_lower:checked').val()) || (jQuery('#disabilityallowance_medium:checked').val()) || (jQuery('#disabilitymobility_medium:checked').val()) || (jQuery('#armedforces_yes:checked').val()) || (jQuery('#personalindepenence_higher:checked').val()) || (jQuery('#personalindepenence_mobility_higher:checked').val()) || (jQuery('#attendanceallowance_lower:checked').val()))) {
          else if (
            isCarer === "1" &&
            (values.benefits.disabilityallowance_lower === "1" ||
              values.benefits.disabilitymobility_lower === "1" ||
              values.benefits.disabilityallowance_medium === "1" ||
              values.benefits.disabilitymobility_medium === 1 ||
              values.benefits.armedforces_yes === "1" ||
              values.benefits.personalindepenence_higher === "1" ||
              values.benefits.personalindepenence_mobility_higher === "1" ||
              values.benefits.attendanceallowance_lower === "1")
          ) {
            //@json file: lp_carer_lower_allowance
            basicAllowance =
              parseFloat(lp_carer_lower_allowance) + parseFloat(childAdditional)
            maxWeeklyCharge =
              parseFloat(chargableIncome) - parseFloat(basicAllowance)
            //@json file: basicAllowanceDefault
            if (basicAllowance < parseFloat(basicAllowanceDefault)) {
              maxWeeklyCharge =
                parseFloat(chargableIncome) - parseFloat(basicAllowanceDefault)
              //console.log('7');
            } else {
              // nothing, this is the max weekly charge as added up.
              maxWeeklyCharge =
                parseFloat(chargableIncome) - parseFloat(basicAllowance)
              //console.log('8');
            }
          }

          // Disability Living Allowance Higher Rate or PIP Enhanced rate or Attendance Allowance Higher Rate
          // else if ((isCarer === 0) && ((jQuery('#disabilityallowance_higher:checked').val()) || (jQuery('#personalindepenence_higher:checked').val()) || (jQuery('#personalindepenence_mobility_higher:checked').val()) || (jQuery('#attendanceallowance_higher:checked').val()))) {
          else if (
            isCarer === "0" &&
            (values.benefits.disabilityallowance_higher === "1" ||
              values.benefits.personalindepenence_higher === "1" ||
              values.benefits.personalindepenence_mobility_higher === "1" ||
              values.benefits.attendanceallowance_higher === "1")
          ) {
            //@json file: lp_notcarer_higher_allowance
            basicAllowance =
              parseFloat(lp_notcarer_higher_allowance) +
              parseFloat(childAdditional)
            maxWeeklyCharge =
              parseFloat(chargableIncome) - parseFloat(basicAllowance)
            //@json file: basicAllowanceDefault
            if (basicAllowance < parseFloat(basicAllowanceDefault)) {
              maxWeeklyCharge =
                parseFloat(chargableIncome) - parseFloat(basicAllowanceDefault)
              //console.log('9');
            } else {
              // nothing, this is the max weekly charge as added up.
              maxWeeklyCharge =
                parseFloat(chargableIncome) - parseFloat(basicAllowance)
              //console.log('10');
            }
          }

          // Disability Living Allowance Higher Rate or PIP Enhanced rate or Attendance Allowance Higher Rate AND carer
          //else if ((isCarer == 1) && ((jQuery('#disabilityallowance_higher:checked').val()) || (jQuery('#disabilitymobility_higher:checked').val()) || (jQuery('#personalindepenence_higher:checked').val()) || (jQuery('#attendanceallowance_higher:checked').val()))) {
          else if (
            isCarer === "1" &&
            (values.benefits.disabilityallowance_higher === "1" ||
              values.benefits.disabilitymobility_higher === "1" ||
              values.benefits.personalindepenence_higher === "1" ||
              values.benefits.attendanceallowance_higher === "1")
          ) {
            //@json file: lp_carer_higher_allowance
            basicAllowance =
              parseFloat(lp_carer_higher_allowance) +
              parseFloat(childAdditional)
            maxWeeklyCharge =
              parseFloat(chargableIncome) - parseFloat(basicAllowance)
            //@json file: basicAllowanceDefault
            if (basicAllowance < parseFloat(basicAllowanceDefault)) {
              maxWeeklyCharge =
                parseFloat(chargableIncome) - parseFloat(basicAllowanceDefault)
              //console.log('11');
            } else {
              // nothing, this is the max weekly charge as added up.
              maxWeeklyCharge =
                parseFloat(chargableIncome) - parseFloat(basicAllowance)
              //console.log('12');
            }
            //update how much they need to pay
          }
          //if carer
          else if (isCarer === "1") {
            //they are a carer
            //@json file: carer_child_allowance
            basicAllowance =
              parseFloat(carer_child_allowance) + parseFloat(childAdditional)
            maxWeeklyCharge =
              parseFloat(chargableIncome) - parseFloat(basicAllowance)
            //@json file: basicAllowanceDefault
            if (basicAllowance < parseFloat(basicAllowanceDefault)) {
              maxWeeklyCharge =
                parseFloat(chargableIncome) - parseFloat(basicAllowanceDefault)
              //console.log('3');
            } else {
              // nothing, this is the max weekly charge as added up.
              maxWeeklyCharge =
                parseFloat(chargableIncome) - parseFloat(basicAllowance)
              //console.log('4');
            }
          } else {
            //@json file: basicAllowanceDefault
            maxWeeklyCharge =
              parseFloat(chargableIncome) - parseFloat(basicAllowanceDefault)
            //console.log('25');
          }

          //  jQuery('#contributeamount').html('<p>You may need to contribute up to £' + maxWeeklyCharge.toFixed(2) + ' a week towards the cost of your care</p>');
          //console.log('loneparent');
          contributeAmount =
            "You may need to contribute up to £" +
            maxWeeklyCharge.toFixed(2) +
            " a week towards the cost of your care"
          console.log("may have to pay X")
        } else if (ageGroup === "overstate") {
          // over state pension age

          // Disability Living Allowance Lower Rate or PIP Standard rate or Entitled to Armed Forces Independence Payment or Attendance Allowance Lower Rate
          //if ((isCarer == 0) && ((jQuery('#disabilityallowance_lower:checked').val()) || (jQuery('#disabilitymobility_lower:checked').val()) || (jQuery('#personalindepenence_lower:checked').val()) || (jQuery('#personalindepenence_mobility_lower:checked').val()) || (jQuery('#armedforces_yes:checked').val()) || (jQuery('#attendanceallowance_lower:checked').val()))) {
          if (
            isCarer === "0" &&
            (values.benefits.disabilityallowance_lower === "1" ||
              values.benefits.disabilitymobility_lower === "1" ||
              values.benefits.personalindepenence_lower === "1" ||
              values.benefits.personalindepenence_mobility_lower === "1" ||
              values.benefits.armedforces_yes === "1" ||
              values.benefits.attendanceallowance_lower === "1")
          ) {
            //@json file: basicAllowanceDefault
            maxWeeklyCharge =
              parseFloat(chargableIncome) - parseFloat(basicAllowanceDefault)
            //console.log('14');
          }

          // Carer and Disability Living Allowance Lower/Med Rate or PIP standard rate or Entitled to Armed Forces Independence Payment or Attendance Allowance Lower Rate?
          // else if ((isCarer == 1) && ((jQuery('#disabilityallowance_lower:checked').val()) || (jQuery('#disabilitymobility_lower:checked').val()) || (jQuery('#disabilityallowance_medium:checked').val()) || (jQuery('#disabilitymobility_medium:checked').val()) || (jQuery('#armedforces_yes:checked').val()) || (jQuery('#personalindepenence_higher:checked').val()) || (jQuery('#personalindepenence_mobility_higher:checked').val()) || (jQuery('#attendanceallowance_lower:checked').val()))) {
          else if (
            isCarer === "1" &&
            (values.benefits.disabilityallowance_lower === "1" ||
              values.benefits.disabilitymobility_lower === "1" ||
              values.benefits.disabilityallowance_medium === "1" ||
              values.benefits.disabilitymobility_medium === 1 ||
              values.benefits.armedforces_yes === "1" ||
              values.benefits.personalindepenence_higher === "1" ||
              values.benefits.personalindepenence_mobility_higher === "1" ||
              values.benefits.attendanceallowance_lower === "1")
          ) {
            //@json file: basicAllowanceDefault
            maxWeeklyCharge =
              parseFloat(chargableIncome) - parseFloat(basicAllowanceDefault)
            //console.log('15');
          }

          // Disability Living Allowance Higher Rate or PIP Enhanced rate or Attendance Allowance Higher Rate
          // else if ((isCarer == 0) && ((jQuery('#disabilityallowance_higher:checked').val()) || (jQuery('#personalindepenence_higher:checked').val()) || (jQuery('#personalindepenence_mobilility_higher:checked').val()) || (jQuery('#attendanceallowance_higher:checked').val()))) {
          else if (
            isCarer === "0" &&
            (values.benefits.disabilityallowance_higher === "1" ||
              values.benefits.personalindepenence_higher === "1" ||
              values.benefits.personalindepenence_mobilility_higher === "1" ||
              values.benefits.attendanceallowance_higher === "1")
          ) {
            //@json file: basicAllowanceDefault
            maxWeeklyCharge =
              parseFloat(chargableIncome) - parseFloat(basicAllowanceDefault)
            //console.log('16');
          }

          // Disability Living Allowance Higher Rate or PIP Enhanced rate or Attendance Allowance Higher Rate AND carer
          //else if ((isCarer == 1) && ((jQuery('#disabilityallowance_higher:checked').val()) || (jQuery('#disabilitymobility_higher:checked').val()) || (jQuery('#personalindepenence_higher:checked').val()) || (jQuery('#personalindepenence_mobility_higher:checked').val()) || (jQuery('#attendanceallowance_higher:checked').val()))) {
          else if (
            isCarer === "1" &&
            (values.benefits.disabilityallowance_higher === "1" ||
              values.benefits.disabilitymobility_higher === "1" ||
              values.benefits.personalindepenence_higher === "1" ||
              values.benefits.personalindepenence_mobility_higher === "1" ||
              values.benefits.attendanceallowance_higher === "1")
          ) {
            //@json file: basicAllowanceDefault
            maxWeeklyCharge =
              parseFloat(chargableIncome) - parseFloat(basicAllowanceDefault)
            //console.log('17');
          } else if (isCarer === "1") {
            //they are a carer
            //@json file: carer_overstate_allowance
            maxWeeklyCharge =
              parseFloat(chargableIncome) -
              parseFloat(carer_overstate_allowance)
            //console.log('13');
          } else {
            //@json file: basicAllowanceDefault
            maxWeeklyCharge =
              parseFloat(chargableIncome) - parseFloat(basicAllowanceDefault)
          }
          //update how much they need to pay
          contributeAmount =
            "You may need to contribute up to £" +
            maxWeeklyCharge.toFixed(2) +
            " a week towards the cost of your care"
          console.log("may have to pay X")
        } else if (ageGroup === "25-state") {
          // 25-state pension

          //if carer

          // Disability Living Allowance Lower Rate or PIP Standard rate or Entitled to Armed Forces Independence Payment or Attendance Allowance Lower Rate
          //if ((isCarer == 0) && ((jQuery('#disabilityallowance_lower:checked').val()) || (jQuery('#disabilitymobility_lower:checked').val()) || (jQuery('#personalindepenence_lower:checked').val()) || (jQuery('#personalindepenence_mobility_lower:checked').val()) || (jQuery('#armedforces_yes:checked').val()) || (jQuery('#attendanceallowance_lower:checked').val()))) {
          if (
            isCarer === "0" &&
            (values.benefits.disabilityallowance_lower === "1" ||
              values.benefits.disabilitymobility_lower === "1" ||
              values.benefits.personalindepenence_lower === "1" ||
              values.benefits.personalindepenence_mobility_lower === "1" ||
              values.benefits.armedforces_yes === "1" ||
              values.benefits.attendanceallowance_lower === "1")
          ) {
            //@json file: basicAllowanceDefault
            maxWeeklyCharge =
              parseFloat(chargableIncome) - parseFloat(basicAllowanceDefault)
            //console.log(maxWeeklyCharge);
            //console.log('19');
          }

          // Carer and Disability Living Allowance Lower/Med Rate or PIP standard rate or Entitled to Armed Forces Independence Payment or Attendance Allowance Lower Rate?
          // else if ((isCarer == 1) && ((jQuery('#disabilityallowance_lower:checked').val()) || (jQuery('#disabilitymobility_lower:checked').val()) || (jQuery('#disabilityallowance_medium:checked').val()) || (jQuery('#disabilitymobility_medium:checked').val()) || (jQuery('#armedforces_yes:checked').val()) || (jQuery('#personalindepenence_higher:checked').val()) || (jQuery('#personalindepenence_mobility_higher:checked').val()) || (jQuery('#attendanceallowance_lower:checked').val()))) {
          else if (
            isCarer === "1" &&
            (values.benefits.disabilityallowance_lower === "1" ||
              values.benefits.disabilitymobility_lower === "1" ||
              values.benefits.disabilityallowance_medium === "1" ||
              values.benefits.disabilitymobility_medium === "1" ||
              values.benefits.armedforces_yes === "1" ||
              values.benefits.personalindepenence_higher === "1" ||
              values.benefits.personalindepenence_mobility_higher === "1" ||
              values.benefits.attendanceallowance_lower === "1")
          ) {
            //@json file: basicAllowanceDefault
            maxWeeklyCharge =
              parseFloat(chargableIncome) - parseFloat(basicAllowanceDefault)
            //console.log('20');
          }

          // Disability Living Allowance Higher Rate or PIP Enhanced rate or Attendance Allowance Higher Rate
          //else if ((isCarer == 0) && ((jQuery('#disabilityallowance_higher:checked').val()) || (jQuery('#personalindepenence_higher:checked').val()) || (jQuery('#attendanceallowance_higher:checked').val()))) {
          else if (
            isCarer === 0 &&
            (values.benefits.disabilityallowance_higher === 1 ||
              values.benefits.personalindepenence_higher === 1 ||
              values.benefits.attendanceallowance_higher === 1)
          ) {
            //@json file: basicAllowanceDefault
            maxWeeklyCharge =
              parseFloat(chargableIncome) - parseFloat(basicAllowanceDefault)
            //console.log('21');
          }

          // Disability Living Allowance Higher Rate or PIP Enhanced rate or Attendance Allowance Higher Rate AND carer
          //else if ((isCarer == 1) && ((jQuery('#disabilityallowance_higher:checked').val()) || (jQuery('#disabilitymobility_higher:checked').val()) || (jQuery('#personalindepenence_higher:checked').val()) || (jQuery('#personalindepenence_mobility_higher:checked').val()) || (jQuery('#attendanceallowance_higher:checked').val()))) {
          else if (
            isCarer === "1" &&
            (values.benefits.disabilityallowance_higher === "1" ||
              values.benefits.disabilitymobility_higher === "1" ||
              values.benefits.personalindepenence_higher === "1" ||
              values.benefits.personalindepenence_mobility_higher === "1" ||
              values.benefits.attendanceallowance_higher === "1")
          ) {
            //@json file: carer_25state_higher_allowance
            maxWeeklyCharge =
              parseFloat(chargableIncome) -
              parseFloat(carer_25state_higher_allowance)
            //console.log('22');
          } else if (isCarer === "1") {
            //they are a carer
            //@json file: basicAllowanceDefault
            maxWeeklyCharge =
              parseFloat(chargableIncome) - parseFloat(basicAllowanceDefault)
            //console.log('18');
          } else {
            //@json file: basicAllowanceDefault
            maxWeeklyCharge =
              parseFloat(chargableIncome) - parseFloat(basicAllowanceDefault)
          }
          //update how much they need to pay
          contributeAmount =
            "You may need to contribute up to £" +
            maxWeeklyCharge.toFixed(2) +
            " a week towards the cost of your care"
          console.log("may have to pay X")
          //console.log('25-state');
        } else {
          //assumes its 18-24 or it doesn't know.
          //@json file: basicAllowanceDefault
          maxWeeklyCharge =
            parseFloat(chargableIncome) - parseFloat(basicAllowanceDefault)
          //console.log('23');
          //console.log('18-25');
        }
        //console.log(maxWeeklyCharge);
        if (maxWeeklyCharge < 0) {
          //if in negatives, they have to pay 0.00 towards
          //console.log('24')
          maxWeeklyCharge = 0
        }

        //update how much they need to pay
        contributeAmount =
          "You may need to contribute up to £" +
          maxWeeklyCharge.toFixed(2) +
          " a week towards the cost of your care"
        console.log("may have to pay X")
      }

      //   debugger;
    }

    console.log(maxWeeklyCharge)
    console.log("contributeamount:" + contributeAmount)
    console.log("totalsavings:" + totalAssets)
    console.log("typeofcare:" + typeOfCareLabel)

    console.log(values)
    return {
      canNotProceed: true,
      // message: 'thanks',
      contribute: contributeAmount,
      savings: totalAssets,
      caretype: typeOfCareLabel,
    }
  }, [])

  return (
    <FormikWizard steps={schema} onSubmit={handleSubmit} render={FormWrapper} />
  )
}

export default App
